// @ts-nocheck
import cn from "classnames";
import {
  IonCol,
  IonItem,
  IonRow,
  IonSelect,
  IonSelectOption
} from "@ionic/react";
import React, { FC, useState } from "react";
import { WrapperFilterSortProps } from "./WrapperFilterSort.model";

const WrapperFilterSort: FC<WrapperFilterSortProps> = ({
  options,
  configSort,
  setSearchFilter,
  data,
  sort,
  setSort,
}) => {
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [openSort, setOpenSort] = useState<boolean>(false);

  return (
    <IonRow className="no-border bills-content-filter-wrapper">
      <IonCol className="no-border no-padding bills-content-filter-wrapper-col">
        <IonItem className="no-border bills-content-filter">
          <IonSelect
            interface="popover"
            placeholder="Sort by"
            className={cn("bills-content-sort", {'active': openSort})}
            onIonChange={(event) => {
              setSort(event?.detail?.value)
              setOpenSort(false)
            }}
            onFocus={() => setOpenSort(false)}
            onClick={() => setOpenSort(true)}
          >
            {options?.map((item) => (
              <IonSelectOption
                key={item?.title}
                value={item}
                className={cn('bills-select-option', {
                  'desc': item?.title === sort?.title && sort?.value === configSort[item?.title].initialValue,
                  'asc': item?.title === sort?.title && !(sort?.value === configSort[item?.title].initialValue),
                })}
              >
                {item?.title}
              </IonSelectOption>
            ))}
          </IonSelect>
        </IonItem>
        <IonItem className="no-border bills-content-filter">
          <IonSelect
            interface="popover"
            placeholder="Filter by"
            className={cn("bills-content-sort", {'active': openFilter})}
            onIonChange={(event) => {
              setSearchFilter(event.detail.value)
              setOpenFilter(false)
            }}
            onFocus={() => setOpenFilter(false)}
            onClick={() => setOpenFilter(true)}
          >
            <IonSelectOption
              key="default"
              value=""
              className="bills-select-option"
            >
              Filter by
            </IonSelectOption>
            {[... new Set(data?.map(payment => payment.provider).filter(provider => provider?.name))].map(provider =>
              <IonSelectOption
                value={provider?.name}
                className={cn('bills-select-option', {})} >
                {provider?.name}
              </IonSelectOption>
            )}
          </IonSelect>
        </IonItem>
      </IonCol>
    </IonRow>
  )
}

export default WrapperFilterSort
